import { computed } from 'vue'

import type { ComputedRef, Ref } from 'vue'
import type { KanbanTimeOffBooking } from './interfaces'

import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import { useListsStore } from '@shared/model'
import { resolveUrl } from '@shared/lib/url'
import { useDayjs } from '@shared/lib/format'
import { AppRoute } from '@shared/config'

interface TimeOffBookingOptions {
  booking: Ref<KanbanTimeOffBooking>
}

interface TimeOffBookingReturn {
  refDate: ComputedRef<string>
  refDiscipline: ComputedRef<string>
  refDisciplineHref: ComputedRef<string>
  refGrade: ComputedRef<string>
}

export const useTimeOffBooking = ({ booking }: TimeOffBookingOptions): TimeOffBookingReturn => {
  const listsStore = useListsStore()
  const dayjs = useDayjs()

  const refDate = computed<string>(() => dayjs(booking.value.start).format(DateFormat.SummaryDate))

  const refDiscipline = computed<string>(() => listsStore.getLists?.discipline.code?.[booking.value.code] || '')

  const refGrade = computed<string>(() => listsStore.getLists?.kid.grade?.[booking.value.kid.grade] || booking.value.kid.grade)

  const refDisciplineHref = computed<string>(() => {
    if (!booking.value.discipline_id) return ''

    return resolveUrl(AppRoute.DisciplinesGeneralInfo, { id: booking.value.discipline_id }) || ''
  })

  return {
    refDate,
    refDiscipline,
    refDisciplineHref,
    refGrade,
  }
}
